import { DiscountType } from 'stores/products/types';

export const discountTypeOptions: DiscountType[] = ['fixed', 'percent'];

export const PRICE_DEFAULT_MIN = 0.01;
